import { useEffect, useState } from 'react';
import { APPOINTMENT_PENDING_STATUS } from '../../util/transaction';

export const usePendingAppointment = ({ appointmentEntities, transactionId }) => {
    const [hasPendingAppointment, setHasPendingAppointment] = useState(false);

    useEffect(() => {
        setHasPendingAppointment(
            (appointmentEntities[transactionId] || []).some(
                a => a.status === APPOINTMENT_PENDING_STATUS
            )
        );
    }, [appointmentEntities, transactionId]);

    return { hasPendingAppointment };
};
